import styled, {css} from 'styled-components';

export const NotFoundWrapper = styled.div<any>`
    padding: 0 16px;
    ${({space}) => space && css`
        padding: 32px 16px;
    `}
  .hero {
      width: 100%;
      height: 400px;
      position: relative;
  }
  p {
      text-align: center;
      margin-top: 20px;
      font-size: 20px;
      font-weight: 700;
      line-height: 1.8;
      margin: 20px auto 40px;
      max-width: 540px;
      text-align: center;
  }
  a {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 390px;
      height: 56px;
      border-radius: 12px;
      background-color: var(--black);
      font-size: 16px;
      font-weight: 700;
      color: #fff;
      svg {
          margin-right: 12px;
      }
  }
  @media screen and (max-width: 740px) {
      padding-top: 32px;
    .hero {
        height: 200px;
    }
    p {
        font-size: 16px;
        margin: 16px 0 20px;
    }
    a {
        height: 48px;
        width: 100%;
        font-size: 14px;
    }
  }
`;
